const CONSOLE_ENABLED = process.env.VUE_APP_CONSOLE_ON;

const ticksToDate = require('ticks-to-date');

import {useSecurityStore} from '@/dod/store/dsecurity';
import {useTranslationsStore} from '@/dod/store/dtranslations';

export default{
    decodeToken(token)
    {
        var base64Url = token.split('.')[ 1 ];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c)
        {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    },
    getToken()
    {
        const secStore = useSecurityStore();
            
        let token = secStore.token;
        if (token)
            return token;
        else
            return false;
    },
    tokenTimeLeft()
    {
        var rawtoken = this.getToken();
        var token = this.decodeToken(rawtoken);
        var exp = ticksToDate(token.TicksUTC);
        var now = new Date(new Date().toUTCString());
        var ms_left = exp - now;
        return ms_left;
    },
    scroll(element, options)
    {
        var topPos = this.position(element).top;
        var wh = window.outerHeight;
        var bh = this.bodyHeight();
        if (topPos > 0)
        {
            if (options && options.center)
            {
                if ((bh - (wh / 2)) > topPos)
                {
                    topPos -= (wh / 2);
                }
            }
            if (options && options.offset)
            {
                topPos -= options.offset;
            }

            window.scrollTo({
                left: 0,
                top: topPos,
                behavior: 'smooth'
            });
        }
    },
    bodyHeight()
    {
        var body = document.body,
            html = document.documentElement;

        return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    },
    bodyWidth()
    {
        var body = document.body, html = document.documentElement;
        return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
    },
    clone(item)
    {
        var json = JSON.stringify(item);
        return JSON.parse(json);
    },
    empty(obj)
    {
        return JSON.stringify(obj) === JSON.stringify({});
    },
    printlog(text)
    {
        if (CONSOLE_ENABLED == "true")
            console.log(text);        
    },
    printerror(error)
    {
        if (CONSOLE_ENABLED == "true")
            console.error(error);
    },
    isLoading(){
        const secStore = useSecurityStore();
        const languageStore = useTranslationsStore();

        var global_loaders = [ secStore, languageStore ];
        var loading = false;
        for (var i = 0; i < arguments.length; i++)
        {
            var l =  arguments[i]?.loading ?? false;
            if (l)
                loading = true;
        }
        for (i = 0; i < global_loaders.length; i++)
        {
            l = global_loaders[i]?.loading ?? false;
            if (l)
                loading = true;
        }
       
        return loading;
    },
    translate(key, replace_values)
    {
        const languageStore = useTranslationsStore();
        return languageStore.translate(key, replace_values);
    }
}